import { useStandardOperatingProcedure } from '../hooks/useStandardOperatingProcedure'
import { useSelector } from 'react-redux'

import {
  Box,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'

import { selectSOP } from '@/redux/ui/uiSlice'

import { SOPDocument } from './SOPDocument'

interface SOPModalIProps {
  isOpen: boolean
  onClose: () => void
}

export const SOPModal = ({ isOpen, onClose }: SOPModalIProps) => {
  const { id } = useSelector(selectSOP)
  const { data, isLoading, error } = useStandardOperatingProcedure({ id })

  if (error) {
    return (
      <Modal isOpen={isOpen} motionPreset='slideInBottom' onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Error</ModalHeader>
          <ModalCloseButton size='lg' />
          <ModalBody>
            <Box py={8} textAlign='center'>
              <Text color='red.600' fontSize='md'>
                Failed to load SOP document. Please try again.
              </Text>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    )
  }

  return (
    <Modal isOpen={isOpen} motionPreset='slideInBottom' onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        borderRadius='md'
        h='92vh'
        m='auto'
        maxW='95vw'
        my='4vh'
        overflow='hidden'
      >
        <ModalHeader
          borderBottom='1px solid #D5DCE4'
          fontSize='18px'
          fontWeight='600'
          py={4}
        >
          {isLoading ? 'Loading SOP...' : data?.name || 'Untitled SOP'}
        </ModalHeader>
        <ModalCloseButton size='lg' />
        <ModalBody flex='1' overflow='hidden' p={0}>
          <SOPDocument isLoading={isLoading} sop={data} />
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
